import { Injectable } from "@angular/core";
import * as moment from "moment";

@Injectable()
export class TimeService {

	constructor() {
	}

	public getTimeRemaining(targetDate: Date): moment.Moment {

		let utcNow = moment.utc();
		let utcTarget = moment.utc(targetDate);
		var duration = moment.duration(utcTarget.diff(utcNow));

		if (duration.asMilliseconds() <= 0) {

			return moment('00:00', 'HH:mm')
		}

		let d = duration.days();
		let h = duration.hours();
		let m = duration.minutes();

		return moment(`${d}:${h}:${m}`, 'dd:HH:mm');
	}

	formatTimeRemaining(timeRemaining: moment.Moment, target: Date): string {
		
		let date = new Date(target);
		let currentDate = new Date();

		const days = Math.floor((date.getTime() - currentDate.getTime()) / 1000 / 60 / 60 / 24);

		const hours = timeRemaining.hours();
		const minutes = timeRemaining.minutes();
		timeRemaining.set('days', days);		

		if (hours <= 0 && minutes <= 0) {

			return null;
		}

		if (hours <= 0) {

			return timeRemaining.format('m [min]')
		}

		if(days <= 0){

			return timeRemaining.format('H [uur] m [min]')
		}

		return timeRemaining.format('d [dagen] H [uur] m [min]')
	}
}